.container {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;

  &.triggerable {
    // TODO: temporary class for demo
    > span:first-child {
      color: var(--dust-red-5-color);
    }
  }

  :global {
    .ant-divider:first-child {
      display: none;
    }
  }
}

.icon {
  &[data-insight-key="exploitable"] {
    color: var(--dust-red-6-color);
  }

  > svg {
    opacity: 0.2;
  }

  &.active {
    > svg {
      opacity: 1;
    }
  }
}
